/* eslint-disable no-void */
/* eslint-disable no-underscore-dangle */

import { ENV } from "@/env"

/** 是否在服务器端 */
export const isServer: boolean = typeof window === 'undefined'
export const _a = (isServer ? {} : window.navigator).userAgent
export const userAgent = _a === void 0 ? '' : _a

/**
 * 是否在微信内
 * @property isInWeChat
 * @type {Boolean}
 */
export const isInWeChat: boolean = /\bMicroMessenger\b/i.test(userAgent)

/**
 * 是否在QQ或iPad QQ内
 * @property isInQQ
 * @type {Boolean}
 */
export const isInQQ: boolean = /\b(IPad)?QQ\b/.test(userAgent)

/**
 * 是否在QQ浏览器内
 * @property isInQQBrowser
 * @type {Boolean}
 */
export const isInQQBrowser: boolean = /\bMQQBrowser\b/.test(userAgent)

/**
 * 是否在微博内
 * @property isInWeibo
 * @type {Boolean}
 */
export const isInWeibo: boolean = /\bWeibo\b/.test(userAgent)

/**
 * 是否在小米浏览器内
 * @property isMiBrowser
 * @type {Boolean}
 */
export const isMiBrowser: boolean = /\bmiuibrowser\b/i.test(userAgent)

/**
 * 是否在华为浏览器内
 * @property isHuaweiBrowser
 * @type {Boolean}
 */
export const isHuaweiBrowser: boolean = /\bhuaweibrowser\b/i.test(userAgent)

/**
 * 是否在非浏览器的APP内（目前只能判断一部分APP）
 * @property isInApp
 * @type {Boolean}
 */
export const isInApp: boolean = isInWeChat || isInQQ || isInWeibo

/**
 * 是否在iOS设备下
 * @property isIOS
 * @type {Boolean}
 */
export const isIOS = /\b(?:iPad|iPod|iPhone)\b/.test(userAgent)
    && /\bOS(?:\s([\d_.]+))?\slike\sMac\sOS\sX\b/.test(userAgent)

/**
 * 是否在Android设备下
 * @property isAndroid
 * @type {Boolean}
 */
export const isAndroid = /\b(?:Android|Adr|YunOS)\b/.test(userAgent) || isMiBrowser || isHuaweiBrowser

/**
 * 是否是华为设备
 * @property isHuaWeiPhone
 * @type {Boolean}
 */
export const isHuaWeiPhone: boolean = /\b(?:HUAWEI|HONOR|HW-)\b/.test(userAgent)

/**
 * 是否移动端
 * @type {Boolean}
 */
export const isMobile: boolean = isAndroid || isIOS
// 判断当前浏览类型
export function getBrowserType() {
  if (!isServer && (window.ActiveXObject || 'ActiveXObject' in window)) { // IE
    let reIE = new RegExp('MSIE (\\d+\\.\\d+)')
    reIE.test(userAgent)
    let fIEVersion = parseFloat(RegExp.$1)
    return 'IE'.concat(fIEVersion.toString() || '低版本')
  } else if (userAgent.indexOf('Firefox') !== -1) {
    return 'Firefox(火狐)'
  } else if (userAgent.indexOf('Opera') !== -1) {
    return 'Opera'
  } else if (userAgent.indexOf('Edge') !== -1) {
    return 'Edge'
  } else if (userAgent.indexOf('QQ') !== -1 && userAgent.indexOf('QQBrowser') === 1) {
    return '手机QQ'
  } else if (userAgent.indexOf('QQBrowser') !== -1) {
    return 'QQ浏览器'
  } else if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('MetaSr') !== -1) {
    return '搜狗浏览器'
  } else if (userAgent.indexOf('MicroMessenger') !== -1) {
    return '微信浏览器'
  } else if (userAgent.indexOf('LBBROWSER') !== -1) {
    return '猎豹浏览器'
  } else if (userAgent.indexOf('Maxthon') !== -1) {
    return '遨游浏览器'
  } else if (userAgent.indexOf('TheWorld') !== -1) {
    return '世界之窗浏览器'
  } else if (userAgent.indexOf('bWeibo') !== -1) {
    return '微博'
  } else if (userAgent.indexOf('ubrowser') !== -1) {
    return 'UC'
  } else if (userAgent.indexOf('bidubrowser') !== -1) {
    return '百度'
  } else if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1) {
    return 'Safari'
  } else if (userAgent.indexOf('Chrome') !== -1) {
    return 'Chrome'
  } else {
    return ''
  }
}

/**
 * 判断是否是生产环境
 * @returns {boolean} - 是否生产环境
 */
export const isProduct = ENV.VITE_APP_API_ENV === 'prod'


export const browserType: string = getBrowserType()

/**
 * 获取当前域名（包含协议和端口）
 * @returns {string} - 例如: https://example.com:8080
 */
export const getOrigin = (): string => {
  return window.location.origin
}

/**
 * 获取当前路径
 * @returns {string} - 例如: /path/to/page
 */
export const getPathname = (): string => {
  return window.location.pathname
}

/**
 * 获取当前查询参数字符串
 * @returns {string} - 例如: ?id=123&name=test
 */
export const getSearch = (): string => {
  return window.location.search
}

/**
 * 获取完整 URL
 * @returns {string} - 例如: https://example.com:8080/path/to/page?id=123
 */
export const getFullUrl = (): string => {
  return window.location.href
}

/**
 * 获取当前域名origin
 * @returns {string} - 例如: https://example.com:8080
 */
export const getDomainOrigin = (): string => {
  return window.location.origin
}